import { render, staticRenderFns } from "./Leitura.vue?vue&type=template&id=c72587dc&scoped=true"
import script from "./Leitura.vue?vue&type=script&lang=js"
export * from "./Leitura.vue?vue&type=script&lang=js"
import style0 from "./Leitura.vue?vue&type=style&index=0&id=c72587dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72587dc",
  null
  
)

export default component.exports